import React from "react";
import { Modal, ModalContent, ModalBody } from "@heroui/react";
import { useTranslation } from "react-i18next";

import DebugFP from "../internal/DebugFP";

const InternalDebugModal = ({ isOpen, onClose, index }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      backdrop="transparent"
      placement="top-center"
      scrollBehavior="inside"
      classNames={{
        body: "shadow-2xl",
        backdrop: "bg-gradient-to-t from-vistadark/80 to-vistadark/60 backdrop-opacity-20",
      }}
    >
      <ModalContent style={{ maxWidth: '48%', maxHeight: '80%', position: "fixed", right:"0"}}>
        <ModalBody>
          <div className="flex justify-center items-center p-8">
            {t("modal_debug")}
          </div>
          <DebugFP index={index} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default InternalDebugModal;